import { createSlice } from '@reduxjs/toolkit'

export type UserState = {
  userData: UserData;
  loading: Boolean;
  manageUsers: UserData[]
}

export type UserData = {
  email: string;
  firstName: string;
  userId: string;
  isVerified: Boolean;
  jwtToken: string;
  lastName: string;
  userAccounts: AccountObject[],
  organization: string;
  refreshToken: string;
  subscriptionStatus: string
}

export type AccountObject = {
  userAccountId: string;
  userId: string;
  organizationId: string;
  userType: string;
  patientId: string;
  clientId: string;
}

export const defaultUserState: UserState = {
  userData: {
    userId: "",
    organization: "",
    firstName: "",
    lastName: "",
    email: "",
    refreshToken: "",
    isVerified: false,
    jwtToken: "",
    userAccounts: [],
    subscriptionStatus: 'INACTIVE'
  },
  manageUsers: [],
  loading: false
}

export const userSlice = createSlice({
  name: 'user',
  initialState: defaultUserState,
  reducers: {
    setUserDetails: (state, action) => {
      state.userData = action.payload;
    },
    logout: (state) => {
      state.userData = defaultUserState.userData;
    },
    updateUserSubscription: (state, action) => {
      state.userData.subscriptionStatus = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setUserDetails, logout, updateUserSubscription } = userSlice.actions

export default userSlice.reducer